import { createFileRoute } from '@tanstack/react-router';
import z from 'zod';
import { Settings } from '../../organisms/Settings';

const ZodSearchParams = z.object({
  verifyEmail: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/settings')({
  component: Settings,
  validateSearch: (search) => ZodSearchParams.parse(search),
});
